import { openBlock, createElementBlock, renderSlot, resolveComponent, Fragment, createVNode, createElementVNode, toDisplayString, createTextVNode, createCommentVNode, mergeProps, createBlock, resolveDynamicComponent, withCtx, Transition, withDirectives, vShow } from 'vue';
import { s as script$3 } from './Icon-fJqkx1gN.js';
import { c as config } from './config-nHWiBviw.js';
import { C as CompatFallthroughMixin } from './CompatFallthroughMixin-Ev2XGfi3.js';
import { a as registerComponent } from './plugins-C7548x21.js';
import './helpers-O9h6_ICO.js';
import './typeof-Z4rCTFCZ.js';

var MenuItemContainerMixin = {
  provide: function provide() {
    return {
      BMenuItemContainer: this
    };
  },
  data: function data() {
    return {
      menuItems: []
    };
  },
  methods: {
    appendMenuItem: function appendMenuItem(item) {
      this.menuItems.push(item);
    },
    removeMenuItem: function removeMenuItem(item) {
      var index = this.menuItems.indexOf(item);
      if (index !== -1) {
        this.menuItems.splice(index, 1);
      }
    }
  }
};

var script$2 = {
    name: 'BMenu',
    mixins: [MenuItemContainerMixin],
    props: {
        accordion: {
            type: Boolean,
            default: true
        },
        activable: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            _isMenu: true // Used by MenuItem
        }
    }
};

const _hoisted_1$2 = { class: "menu" };

function render$2(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createElementBlock("div", _hoisted_1$2, [
    renderSlot(_ctx.$slots, "default")
  ]))
}

script$2.render = render$2;
script$2.__file = "src/components/menu/Menu.vue";

var script$1 = {
    name: 'BMenuList',
    components: {
        [script$3.name]: script$3
    },
    props: {
        label: String,
        icon: String,
        iconPack: String,
        ariaRole: {
            type: String,
            default: ''
        },
        size: {
            type: String,
            default: 'is-small'
        }
    }
};

const _hoisted_1$1 = {
  key: 0,
  class: "menu-label"
};
const _hoisted_2$1 = ["role"];

function render$1(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_b_icon = resolveComponent("b-icon");

  return (openBlock(), createElementBlock(Fragment, null, [
    ($props.label || _ctx.$slots.label)
      ? (openBlock(), createElementBlock("p", _hoisted_1$1, [
          ($props.label)
            ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
                ($props.icon)
                  ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
                      createVNode(_component_b_icon, {
                        icon: $props.icon,
                        pack: $props.iconPack,
                        size: $props.size
                      }, null, 8 /* PROPS */, ["icon", "pack", "size"]),
                      createElementVNode("span", null, toDisplayString($props.label), 1 /* TEXT */)
                    ], 64 /* STABLE_FRAGMENT */))
                  : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                      createTextVNode(toDisplayString($props.label), 1 /* TEXT */)
                    ], 64 /* STABLE_FRAGMENT */))
              ], 64 /* STABLE_FRAGMENT */))
            : renderSlot(_ctx.$slots, "label", { key: 1 })
        ]))
      : createCommentVNode("v-if", true),
    createElementVNode("ul", {
      class: "menu-list",
      role: $props.ariaRole === 'menu' ? $props.ariaRole : undefined
    }, [
      renderSlot(_ctx.$slots, "default")
    ], 8 /* PROPS */, _hoisted_2$1)
  ], 64 /* STABLE_FRAGMENT */))
}

script$1.render = render$1;
script$1.__file = "src/components/menu/MenuList.vue";

var script = {
    name: 'BMenuItem',
    components: {
        [script$3.name]: script$3
    },
    mixins: [CompatFallthroughMixin, MenuItemContainerMixin],
    inject: {
        parent: {
            from: 'BMenuItemContainer',
            default: null
        }
    },
    // deprecated, to replace with default 'value' in the next breaking change
    props: {
        label: String,
        modelValue: Boolean,
        expanded: Boolean,
        disabled: Boolean,
        iconPack: String,
        icon: String,
        animation: {
            type: String,
            default: 'slide'
        },
        tag: {
            type: String,
            default: 'a',
            validator: (value) => {
                return config.defaultLinkTags.indexOf(value) >= 0
            }
        },
        ariaRole: {
            type: String,
            default: ''
        },
        size: {
            type: String,
            default: 'is-small'
        }
    },
    emits: ['update:modelValue', 'update:expanded'],
    data() {
        return {
            newActive: this.modelValue,
            newExpanded: this.expanded
        }
    },
    computed: {
        ariaRoleMenu() {
            return this.ariaRole === 'menuitem' ? this.ariaRole : null
        }
    },
    watch: {
        modelValue(value) {
            this.newActive = value;
        },
        expanded(value) {
            this.newExpanded = value;
        }
    },
    methods: {
        onClick(event) {
            if (this.disabled) return
            const menu = this.getMenu();
            this.reset(this.parent, menu);
            this.newExpanded = this.$props.expanded || !this.newExpanded;
            this.$emit('update:expanded', this.newExpanded);
            if (menu && menu.activable) {
                this.newActive = true;
                this.$emit('update:modelValue', this.newActive);
            }
        },
        reset(parent, menu) {
            if (parent == null) {
                return
            }
            parent.menuItems.forEach((item) => {
                if (item !== this) {
                    this.reset(item, menu);
                    if (!parent.$data._isMenu || (parent.$data._isMenu && parent.accordion)) {
                        item.newExpanded = false;
                        item.$emit('update:expanded', item.newActive);
                    }
                    if (menu && menu.activable) {
                        item.newActive = false;
                        item.$emit('update:modelValue', item.newActive);
                    }
                }
            });
        },
        getMenu() {
            let parent = this.$parent;
            while (parent && !parent.$data._isMenu) {
                parent = parent.$parent;
            }
            return parent
        }
    },
    mounted() {
        if (this.parent) {
            this.parent.appendMenuItem(this);
        }
    },
    beforeUnmount() {
        if (this.parent) {
            this.parent.removeMenuItem(this);
        }
    }
};

const _hoisted_1 = ["role"];
const _hoisted_2 = { key: 1 };

function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_b_icon = resolveComponent("b-icon");

  return (openBlock(), createElementBlock("li", mergeProps({ role: $options.ariaRoleMenu }, _ctx.rootAttrs), [
    (openBlock(), createBlock(resolveDynamicComponent($props.tag), mergeProps(_ctx.fallthroughAttrs, {
      class: {
                'is-active': $data.newActive,
                'is-expanded': $data.newExpanded,
                'is-disabled': $props.disabled,
                'icon-text': $props.icon,
            },
      onClick: _cache[0] || (_cache[0] = $event => ($options.onClick($event)))
    }), {
      default: withCtx(() => [
        ($props.icon)
          ? (openBlock(), createBlock(_component_b_icon, {
              key: 0,
              icon: $props.icon,
              pack: $props.iconPack,
              size: $props.size
            }, null, 8 /* PROPS */, ["icon", "pack", "size"]))
          : createCommentVNode("v-if", true),
        ($props.label)
          ? (openBlock(), createElementBlock("span", _hoisted_2, toDisplayString($props.label), 1 /* TEXT */))
          : renderSlot(_ctx.$slots, "label", {
              key: 2,
              expanded: $data.newExpanded,
              active: $data.newActive
            })
      ]),
      _: 3 /* FORWARDED */
    }, 16 /* FULL_PROPS */, ["class"])),
    createCommentVNode(" sub menu items "),
    (_ctx.$slots.default)
      ? (openBlock(), createBlock(Transition, {
          key: 0,
          name: $props.animation,
          persisted: ""
        }, {
          default: withCtx(() => [
            withDirectives(createElementVNode("ul", null, [
              renderSlot(_ctx.$slots, "default")
            ], 512 /* NEED_PATCH */), [
              [vShow, $data.newExpanded]
            ])
          ]),
          _: 3 /* FORWARDED */
        }, 8 /* PROPS */, ["name"]))
      : createCommentVNode("v-if", true)
  ], 16 /* FULL_PROPS */, _hoisted_1))
}

script.render = render;
script.__file = "src/components/menu/MenuItem.vue";

var Plugin = {
  install: function install(Vue) {
    registerComponent(Vue, script$2);
    // explicit `name` is needed to avoid name mangling of
    // Functional Component in production
    registerComponent(Vue, script$1, 'BMenuList');
    registerComponent(Vue, script);
  }
};

export { script$2 as BMenu, script as BMenuItem, script$1 as BMenuList, Plugin as default };
